import { render } from "./ConfirmRegistration.vue?vue&type=template&id=57be4448&scoped=true"
import script from "./ConfirmRegistration.vue?vue&type=script&lang=js"
export * from "./ConfirmRegistration.vue?vue&type=script&lang=js"

import "./ConfirmRegistration.vue?vue&type=style&index=0&id=57be4448&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-57be4448"

export default script